// extracted by mini-css-extract-plugin
export default {"tabs":"Admin_tabs__AEdkd"};